export class ShreddingMethod {
    id: number;
    name: string;
    createdAt: string;
    updatedAt: string;
  }